import { FieldEnrollment, FieldEnrollmentByFeature } from "../models/fields";
import { BasicFarm } from "../models/farms";
import { Crop } from "../models/crops";
import { FieldEnrollmentsNetworkResponse } from "../models/enrollments";
import { FieldToCropMapping } from "../models/mappings";
import { FieldEnrichments } from "../models/fields";

export const getActiveFields = <FieldLike extends { end?: string | null }>({
  fields,
  now = Date.now(),
}: {
  fields: FieldLike[];
  now?: number;
}): FieldLike[] => {
  return fields.filter((field) => {
    if (field.end === null || field.end === undefined) {
      return true;
    }
    const end = Date.parse(field.end);
    return end >= now;
  });
};

export const enrichField = <
  BasicFieldLike extends { id: string; farmId?: string | null },
>(
  field: BasicFieldLike,
  farmsById: Record<string, BasicFarm | undefined>,
  cropsById: Record<string, Crop | undefined>,
  fieldToCropMapping: FieldToCropMapping,
  fieldsEnrollments?: FieldEnrollmentsNetworkResponse,
): BasicFieldLike & FieldEnrichments => {
  const farm = field.farmId ? farmsById[field.farmId] || null : null;

  const cropId =
    field.id in fieldToCropMapping ? fieldToCropMapping[field.id].cropId : null;

  const crop = cropId ? cropsById[cropId] || null : null;

  const FE = fieldsEnrollments && Object.entries(fieldsEnrollments);

  const enrollments = (FE?.map(([key, value]) => {
    let enrollment = {
      feature: key,
      active: Boolean(value?.find((v) => v.fieldId === field.id)?.active),
    } as FieldEnrollment;

    // Only set the enrollmentDate if it was sent from the API
    const enrollmentDate = value?.find(
      (v) => v.fieldId === field.id,
    )?.enrollmentDate;
    if (enrollmentDate) {
      enrollment = {
        ...enrollment,
        enrollmentDate,
      };
    }
    return enrollment;
  }) || []) as FieldEnrollment[];

  const enrollmentsByFeature = (FE?.map(([key, value]) => ({
    [key]: Boolean(value?.find((v) => v.fieldId === field.id)?.active),
  })).reduce((r, c) => Object.assign(r, c), {}) ||
    {}) as FieldEnrollmentByFeature;

  const fieldEnrichments: FieldEnrichments = {
    cropId,
    farm,
    crop,
    enrollments,
    enrollmentsByFeature,
  };

  return {
    ...field,
    ...fieldEnrichments,
  };
};
